<template>
  <b-container class="home-container text-left">
    <div class="mb-3">
      <b-col clos="12">
        <h1 class="pb-4" style="font-size: 40px;">
          ESG tanácsadókat oktató akkreditált intézmények nyilvántartása
        </h1>
        <h3 style="font-size: 21px;">
          <strong>
            A Magyar Gazdaságfejlesztési Ügynökség által akkreditált ESG tanácsadókat oktató intézmények nyilvántartása
          </strong>
        </h3>
      </b-col>
      <div class="wrapper" style="color: white; display: flex; flex-wrap: wrap; align-items: center;">
        <div class="p-align">
          <div class="p-style mt-2">
            A Magyar Gazdaságfejlesztési Ügynökség az akkreditált, ESG tanácsadókat oktató intézményekről akkreditációs
            tanúsítványuk időbeli érvényessége alatt elektronikus nyilvántartást vezet.
          </div>
          <div class="p-style mt-4">
            Az akkreditáció három évig érvényes. Az akkreditált, ESG tanácsadókat oktató intézmény az akkreditációs
            tanúsítvány érvényességi idejének lejárta előtt legalább hatvan nappal kérheti annak megújítását.
          </div>
          <div class="p-style mt-4">
            Felhívjuk szíves figyelmüket, hogy az akkreditált intézmény 15 napon belül köteles bejelenteni a
            vállalkozásfejlesztési ügynökségnek, ha az akkreditációs feltételeknek már nem felel meg, továbbá, ha a
            244/2024. (VIII. 8.) Korm. Rendelet 3/A. § (3) bekezdésben meghatározott adataiban változás következik be.
          </div>
          <div class="p-style mt-4">
            Az akkreditáció három évig érvényes. Az akkreditált, ESG tanácsadókat oktató intézmény 15 napon belül
            köteles bejelenteni a vállalkozásfejlesztési ügynökségnek, ha az ESG tanácsadókat oktató intézményként
            történő akkreditálás részletes eljárási szabályairól szóló jogszabályban meghatározott adataiban változás
            következik be.
          </div>
        </div>
        <div>
          <img class="logoESGEnterprises-style" src="../assets/img/logoESGEnterprises.png" />
        </div>
      </div>
      <div class="wrapper-small">
        <div class="p-style mb-1" style="padding-left: 20px;">
          Az akkreditációs eljárással kapcsolatos további információkért kattintson az alábbi gombra.
          <a class="button-href" href="/ESG/Akkreditacio">
            Intézmények akkreditációja
          </a>
        </div>
      </div>
    </div>
    <b-col class="mt-5" style="text-align: center;">
      <h1>
        Akkreditált intézmények nyilvántartása
      </h1>
    </b-col>
    <b-row class="mt-5 mb-3">
      <b-col class="text-center desktop-only">
        <strong>
          <!-- görgethetőséget meg kell csinálni-->
          <b-row class="expert-wrapper">
            <b-col cols="12" lg="3" class="expert-title BoxTitle">
              Intézmény hivatalos neve
            </b-col>
            <b-col cols="12" lg="3" class="expert-title BoxTitle">
              Székhelye
            </b-col>
            <b-col cols="12" lg="2" class="expert-title BoxTitle">
              Intézményvezető neve
            </b-col>
            <b-col cols="12" lg="2" class="expert-title BoxTitle">
              Akkreditációs száma
            </b-col>
            <b-col cols="12" lg="2" class="expert-title BoxTitle">
              Akkreditáció érvényessége
            </b-col>
          </b-row>
        </strong>
      </b-col>
      <b-col class="mobile-only">
        <h4>Intézmények Listája</h4>
      </b-col>
    </b-row>
    <b-row class="border border-1 mb-4 rounded" v-for="(expert, index) in experts" :key="index">
      <b-col cols="12" class="mt-3">
        <b-row class="expert-wrapper boxFirst mb-3 mt-3 desktop-only">
          <b-col cols="12" lg="3" class="expert-title">
            <strong class="name">{{ expert.name }}</strong>
          </b-col>
          <b-col cols="12" lg="3" class="expert-title">
            {{ expert.address }}
          </b-col>
          <b-col cols="12" lg="2" class="expert-title">
            {{ expert.leader }}
          </b-col>
          <b-col cols="12" lg="2" class="expert-title">
            {{ expert.code }}
          </b-col>
          <b-col cols="12" lg="2" class="expert-title">
            {{ expert.date }}
          </b-col>
        </b-row>
        <!--mobil -->
        <b-row class="mobile-only">
          <b-col cols="6" lg="3" class="expert-title-mobil BoxTitleMobil">
            Intézmény hivatalos neve
          </b-col>
          <b-col cols="6" lg="3" class="expert-title-mobil">
            <strong class="name">{{ expert.name }}</strong>
          </b-col>
          <b-col cols="6" lg="3" class="expert-title-mobil BoxTitleMobil">
            Székhelye
          </b-col>
          <b-col cols="6" lg="3" class="expert-title-mobil">
            {{ expert.address }}
          </b-col>
          <b-col cols="6" lg="2" class="expert-title-mobil BoxTitleMobil">
            Intézményvezető neve
          </b-col>
          <b-col cols="6" lg="4" class="expert-title-mobil">
            {{ expert.leader }}
          </b-col>
          <b-col cols="6" lg="2" class="expert-title-mobil BoxTitleMobil">
            Akkreditációs száma
          </b-col>
          <b-col cols="6" lg="4" class="expert-title-mobil">
            {{ expert.code }}
          </b-col>
          <b-col cols="6" lg="2" class="expert-title-mobil BoxTitleMobil">
            Akkreditáció érvényessége
          </b-col>
          <b-col cols="6" lg="4" class="expert-title-mobil">
            {{ expert.date }}
          </b-col>
        </b-row>
        <b-row class="boxSecond mt-3">
          <b-col cols="12">
            <b-card-header header-tag="headerv" class="p-0" role="tab">
              <button v-b-toggle="'accordion-' + index" size="sm" class="buttonScrolling">
                Képzés részletei
                <span class="when-opened">
                  <ChevronRightIcon :size="25" />
                </span>
                <span class="when-closed">
                  <ChevronDownIcon :size="25" />
                </span>
              </button>
            </b-card-header>
            <b-collapse v-bind:id="'accordion-' + index">
              <div class="offer-description mt-3">
                <b-row class="blockBox">
                  <b-col cols="12" lg="1"></b-col>
                  <b-col cols="12" lg="6" class="p-5">
                    <competition-small-details :competition="offer" />
                    <b-row class="p-1">
                      <strong style="padding-right: 8px;">
                        Képzés helye:
                      </strong>
                      {{ expert.schooladdress }}
                    </b-row>
                    <b-row class="p-1">
                      <strong style="padding-right: 8px;">
                        Képzési órák száma:
                      </strong>
                      {{ expert.training }}
                    </b-row>
                    <b-row class="p-1">
                      <strong style="padding-right: 8px;">
                        Képzés díja (bruttó):
                      </strong>
                      {{ expert.trainingFee }}
                    </b-row>
                    <b-row class="p-1">
                      <strong style="padding-right: 8px;">
                        Jelenléti képzés aránya:
                      </strong>
                      {{ expert.presence }}
                    </b-row>
                    <b-row class="mt-4">
                      <b-button class="button" @click="handleOpenLinkInNewTab(expert.urlTraning)">
                        Tovább a képzés honlapjára
                      </b-button>
                    </b-row>
                  </b-col>
                  <b-col cols="12" lg="2" class="mt-4 desktop-only">
                    <img :src="expert.logo" class="expert-image" alt="Logó" />
                  </b-col>
                  <b-col cols="12" lg="2"></b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-col>
        </b-row>
        <!--mobil-->
      </b-col>
    </b-row>
    <ESGButton />
  </b-container>
</template>

<script>
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import ESGButton from './ESGButton.vue'
export default {
  name: 'ESGIntezmenyek',
  components: {
    ChevronDownIcon,
    ChevronRightIcon,
    ESGButton
  },
  data() {
    return {
      experts: [
        {
          name: 'Edutus Egyetem', //Intézmény hivatalos megnevezése
          address: '2800 Tatabánya, Stúdium tér 1.', //Székhelye
          leader: 'Némethné Dr. Gál Andrea', //Intézményvezető neve
          code: 'GFÜ/015/2025', //Akreditációszsáma
          date: '2025.11.24-2028.11.24.', //Akkreditáció érvényessége
          schooladdress: '2800 Tatabánya, Stúdium tér 1.', //Képzés helye
          training: '200 óra ', //Képzési órák száma
          trainingFee: '590.000 Ft', //kézpzés díja
          presence: '50%', //jelenléti képzés aránya
          urlTraning: 'https://www.edutus.hu/oktatas/reszismereti-kepzes/esg-tanacsado-kepzes/', //képzés honlapja
          logo: require('../assets/img/logoESGIntezmeny.png') //képzés logója
        },
        {
          name: 'Nemzeti Közszolgálati Egyetem', //Intézmény hivatalos megnevezése
          address: '1083 Budapest, Ludovika tér 2.', //Székhelye
          leader: 'Dr. Deli Gergely', //Intézményvezető neve
          code: 'GFÜ/001/2024', //Akreditációszsáma
          date: '2024.11.28.–2027.11.28.', //Akkreditáció érvényessége
          schooladdress: '1138 Budapest, Váci út 184.', //Képzés helye
          training: '204 óra ', //Képzési órák száma
          trainingFee: '331.000 Ft/félév (ÁFA mentes)', //kézpzés díja
          presence: '50%', //jelenléti képzés aránya
          urlTraning:
            'https://kti.uni-nke.hu/szakiranyu-tovabbkepzesek/szakiranyu-tovabbkepzesi-szakok/esg-szemleletu-gazdasagi-szaktanacsado/esg-tanacsado-reszismereti-kepzes', //képzés honlapja
          logo: require('../assets/img/logoESGIntezmeny.png') //képzés logója
        },
        {
          name: 'Pannon Egyetem', //Intézmény hivatalos megnevezése
          address: '8200 Veszprém, Egyetem utca 10.', //Székhelye
          leader: 'Dr. Abonyi János', //Intézményvezető neve
          code: 'GFÜ/002/2024', //Akreditációszsáma
          date: '2024.12.12.–2027.12.12.', //Akkreditáció érvényessége
          schooladdress: '8200 Veszprém, Egyetem u. 10.', //Képzés helye
          training: '200 óra ', //Képzési órák száma
          trainingFee: '750.000 Ft', //kézpzés díja
          presence: '50%', //jelenléti képzés aránya
          urlTraning: 'https://esgtanacsado.uni-pannon.hu/', //képzés honlapja
          logo: require('../assets/img/logoESGIntezmeny.png') //képzés logója
        },
        {
          name: 'Budapesti Corvinus Egyetem', //Intézmény hivatalos megnevezése
          address: '1093, Budapest, Fővám tér 8.', //Székhelye
          leader: 'Bruno van Pottelsberghe', //Intézményvezető neve
          code: 'GFÜ/003/2024', //Akreditációszsáma
          date: '2024.12.17.–2027.12.17.', //Akkreditáció érvényessége
          schooladdress: '1093, Budapest, Fővám tér 8.', //Képzés helye
          training: '200 óra ', //Képzési órák száma
          trainingFee: '550.000 Ft/félév', //kézpzés díja
          presence: '75%', //jelenléti képzés aránya
          urlTraning: 'https://www.uni-corvinus.hu/post/landing-page/szakiranyu-tovabbkepzesek/esg-kepzesek/', //képzés honlapja
          logo: require('../assets/img/logoESGIntezmeny.png') //képzés logója
        },
        {
          schooladdress: '1093, Budapest, Fővám tér 8.', //Képzés helye
          training: '240 óra ', //Képzési órák száma
          trainingFee: '1.200.000 Ft', //kézpzés díja
          presence: '80%', //jelenléti képzés aránya
          urlTraning:
            'https://www.uni-corvinus.hu/post/landing-page/mesterkepzesek/fenntarthatosagi-menedzsment-es-vallalkozas/', //képzés honlapja
          logo: require('../assets/img/logoESGIntezmeny.png') //képzés logója
        },
        {
          name: 'Debreceni Egyetem', //Intézmény hivatalos megnevezése
          address: '4032 Debrecen, Egyetem tér 1.', //Székhelye
          leader: 'Prof. Dr. Szilvássy Zoltán', //Intézményvezető neve
          code: 'GFÜ/004/2024', //Akreditációszsáma
          date: '2024.12.17.–2027.12.17.', //Akkreditáció érvényessége
          schooladdress: '4032 Debrecen Böszörményi út 138.', //Képzés helye
          training: '205 óra ', //Képzési órák száma
          trainingFee: '600.000 Ft', //kézpzés díja
          presence: '80%', //jelenléti képzés aránya
          urlTraning: 'https://econ.unideb.hu/esg-tanacsado-reszismereti-kepzes', //képzés honlapja
          logo: require('../assets/img/logoESGIntezmeny.png') //képzés logója
        },
        {
          name: 'Széchenyi István Egyetem',
          address: '9026 Győr, Egyetem tér 1.',
          leader: 'Dr. Filep Bálint',
          code: 'GFÜ/005/2024',
          date: '2024.12.19.–2027.12.19.',
          schooladdress: '9026 Győr, Egyetem tér 1.',
          training: '210 óra',
          trainingFee: '900.000 Ft',
          presence: '60%',
          urlTraning: 'https://felveteli.sze.hu/esg-tanacsado',
          logo: require('../assets/img/logoESGIntezmeny.png')
        },
        {
          name: 'Budapesti Metropolitan Egyetem',
          address: '1148 Budapest, Nagy Lajos király útja 1-9.',
          leader: 'Prof. Dr. Kucsera Tamás Gergely',
          code: 'GFÜ/006/2025',
          date: '2025.01.31.–2028.01.31.',
          schooladdress: '1148 Budapest, Nagy Lajos király útja 1-9.',
          training: '200 óra',
          trainingFee: '950.000 Ft',
          presence: '55%',
          urlTraning: 'https://metropolitan.hu/hu/esg-tanacsado',
          logo: require('../assets/img/logoESGIntezmeny.png')
        },
        {
          name: 'Gábor Dénes Egyetem',
          address: '1119 Budapest, Fejér Lipót u. 70.',
          leader: 'Dr. Zimányi Krisztina',
          code: 'GFÜ/007/2025',
          date: '2025.02.24.–2028.02.24.',
          schooladdress: '1119 Budapest, Fejér Lipót u. 70.',
          training: '200 óra',
          trainingFee: '600.000 Ft',
          presence: '100 % (A nemzeti felsőoktatásról szóló 2011. évi CCIV. törvény 108. § 41. értelmében)',
          urlTraning: 'https://esg.gde.hu/',
          logo: require('../assets/img/logoESGIntezmeny.png')
        },
        /*{
          name: 'Miskolci Egyetem',
          address: '3515 Miskolc-Egyetemváros, Egyetem út 1.',
          leader: 'Prof. Dr. Horváth Zita',
          code: 'GFÜ/008/2025',
          date: '2025.03.18.–2028.03.18.',
          schooladdress: '3515 Miskolc-Egyetemváros, Egyetem út 1.',
          training: '224 óra',
          trainingFee: '550.000 Ft',
          presence: '50%',
          urlTraning: 'https://www.uni-miskolc.hu/esg-kepzes/',
          logo: require('../assets/img/logoESGIntezmeny.png')
        },*/
        {
          name: 'Pécsi Tudományegyetem',
          address: '7622 Pécs, Vasvári Pál utca 4.',
          leader: 'Dr. Miseta Attila',
          code: 'GFÜ/009/2025',
          date: '2025.04.01.–2028.04.01.',
          schooladdress: '7622 Pécs, Rákóczi út 80.',
          training: '200 óra',
          trainingFee: '400.000 Ft/félév',
          presence: '58%',
          urlTraning: 'https://cal.ktk.pte.hu/hu/esg-tanacsado',
          logo: require('../assets/img/logoESGIntezmeny.png')
        },
        {
          name: 'Budapesti Műszaki és Gazdaságtudományi Egyetem',
          address: '1111 Budapest, Műegyetem rkp. 3.',
          leader: 'Dr. Charaf Hassan',
          code: 'GFÜ/010/2025',
          date: '2025.05.20.–2028.05.20.',
          schooladdress: '1117 Budapest, Magyar tudósok krt. 2.',
          training: '218 óra',
          trainingFee: '450.000 Ft/félév',
          presence: '54%',
          urlTraning: 'https://www.bme.hu/ESG-tanacsado-kepzes',
          logo: require('../assets/img/logoESGIntezmeny.png')
        },
        {
          name: 'Soproni Egyetem',
          address: '9400 Sopron, Bajcsy-Zsilinszky utca 4.',
          leader: 'Prof. dr. Fábián Attila Gábor',
          code: 'GFÜ/011/2025',
          date: '2025. 06. 17.–2028. 06. 17. ',
          schooladdress: '9400 Sopron, Bajcsy-Zsilinszky u. 4.',
          training: '208 óra',
          trainingFee: '350.000 Ft/félév',
          presence: '52%',
          urlTraning: 'https://www.uni-sopron.hu/esg-tanacsado-reszismereti-kepzes',
          logo: require('../assets/img/logoESGIntezmeny.png')
        },
        {
          name: 'Szegedi Tudományegyetem',
          address: '6720 Szeged, Dugonics tér 13.',
          leader: 'Prof. Dr. Rovó László',
          code: 'GFÜ/012/2025',
          date: '2025. 07. 04. – 2028. 07. 04.',
          schooladdress: '6720 Szeged, Dugonics tér 13.',
          training: '201 óra',
          trainingFee: '900.000 Ft',
          presence: '50%',
          urlTraning: 'https://u-szeged.hu/unihub/esg-tanacsado-reszismereti-kepzes',
          logo: require('../assets/img/logoESGIntezmeny.png')
        },
        {
          name: 'Eötvös Loránd Tudományegyetem',
          address: '1053 Budapest, Egyetem tér 1–3.',
          leader: 'Dr. Darázs Lénárd',
          code: 'GFÜ/013/2025',
          date: '2025. 07. 30. - 2028. 07. 30.',
          schooladdress: '9700 Szombathely, Károlyi Gáspár tér 4.',
          training: '200 óra',
          trainingFee: '350.000 Ft/félév',
          presence: '55%',
          urlTraning: 'https://sek.elte.hu/kozgazdint/fenntarthatosagi-es-esg-tanacsado-reszismereti-kepzes',
          logo: require('../assets/img/logoESGIntezmeny.png')
        },
        {
          name: 'Eszterházy Károly Katolikus Egyetem',
          address: '3300 Eger, Eszterházy tér 1.',
          leader: 'Dr. Pajtókné Dr. Tari Ilona',
          code: 'GFÜ/014/2025',
          date: '2025. 10. 10. - 2028. 10. 10.',
          schooladdress: '3300 Eger, Eszterházy tér 1.',
          training: '204 óra',
          trainingFee: '520.000 Ft',
          presence: '50%',
          urlTraning: ' https://www.uni-eszterhazy.hu/esg-kepzes',
          logo: require('../assets/img/logoESGIntezmeny.png')
        } /*,
        {
          name: 'Nemzetközi Példa Szervezet5',
          address: '2141 Csömör, Páva u. 4',
          leader: 'Alajos Oberfrank',
          code: '555425/2024',
          date: '2024.05.01-2025.12.31',
          schooladdress: '2141 Csömör, Páva u. 4',
          training: '60 óra',
          trainingFee: '120.000Ft',
          presence: '80%',
          urlTraning: 'https://vali.hu',
          logo: require('../assets/img/logoESGIntezmeny.png')
        }*/
      ]
    }
  },
  methods: {
    handleOpenLinkInNewTab(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped>
.boxSecond {
  font-size: larger;
  border-radius: 12px;
  border: black;
}

.blockBox {
  font-size: medium;
}

.button {
  background: #00903c;
  font-weight: 700;
  color: #fff;
  height: 48px;
  line-height: 32px;
  border-radius: 8px;
}

.buttonScrolling {
  width: 100%;
  background-color: white;
  color: #00903c;
  font-weight: bold;
  border: 0;
  outline: none;
  font-size: medium;
}

.name {
  color: #00903c;
}

.BoxTitleMobil {
  font-weight: bold;
  text-align: left;
  display: flex;
  justify-content: flex-start;
}

.expert-image-wrapper {
  height: 100%;
}

.expert-title {
  color: #636e72;
  height: 100%;
  display: flex;
  font-size: large;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.expert-title_date {
  color: #636e72;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expert-title-mobil {
  height: 100%;
  display: flex;
  font-size: large;
  align-items: left;
  justify-content: left;
}
.wrapper {
  background-color: rgba(51, 166, 99);
  border-radius: 10px 10px 0 0;
  padding: 35px;
  margin: auto;
}
.wrapper-small {
  background-color: rgb(204, 233, 216);
  padding: 20px;
  border-radius: 0 0 10px 10px;
}
.button-href {
  background-color: rgba(51, 166, 99);
  color: white;
  padding: 10px 30px;
  border-radius: 9px;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  margin-left: 115px;
}
.p-style {
  font-size: 16px;
  line-height: 1.5;
  text-align: justify;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.logoESGEnterprises-style {
  max-width: 100%;
  height: auto;
}
.p-align {
  flex: 1;
  min-width: 300px;
  padding-right: 20px;
}

.headerBox {
  justify-content: center;
}

.boxFirst {
  border-radius: 12px;
  border: black;
}

.offer-width {
  max-width: 800px;
}

.offerbox-holder {
  padding: 20px;
  padding-top: 30px;
  border: 1px solid var(--color-gray-02);
  box-sizing: border-box;
  box-shadow: 0px 2px 12px rgba(45, 52, 54, 0.05);
  min-height: 80px;
}

.offer-name {
  color: var(--color-green);
  font-weight: bold;
}

.offerbox-holder .btn {
  width: 200px;
  height: 48px;
  padding: 11px;
}

.offer-name:focus {
  outline: none;
}

.offerbox-holder .btn {
  width: 200px;
  height: 48px;
  padding: 11px;
}

.collapsed > div > div > .when-opened,
:not(.collapsed) > div > div > .when-closed {
  display: none;
}

.pre-link {
  width: fit-content;
}

.heart-container {
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 10px;
}

.competition-container {
  position: relative;
}

.offer-button-container {
  background: #ffffff;
  padding: 8px 16px 8px 16px;
  border: 1px solid #dfe6e9;
  box-sizing: border-box;
  border-radius: 4px;
  transition: background 0.1s ease-in-out;
  font-size: 16px;
}

.offer-button-container:hover {
  background: #f2f8fa;
  cursor: pointer;
}

.sub-type-svg-container {
  margin-right: 17px;
}

.activeOfferButton {
  background: #f2f8fa;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

/* Elem elrejtése mobilon */
@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }
}

@media (max-width: 768px) {
  .p-style {
    flex-direction: column;
    align-items: flex-start;
  }

  .button-href {
    margin-left: 0;
    margin-top: 10px;
    width: 100%;
    text-align: center;
  }
}

/* Elem elrejtése asztali böngészőben */
@media (min-width: 769px) {
  .mobile-only {
    display: none;
  }
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: 0px;
  transition: opacity 1s ease-out;
}
</style>
